// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610201535/js/" + chunkId + "." + {"44":"f4eedb84","225":"c80f095c","481":"caad41bd","486":"35cafdbf","770":"cf2b4e54"}[chunkId] + ".0.5628167905446056.chunk.js";
};